import { render, staticRenderFns } from "./Conversations.vue?vue&type=template&id=1a9d05e4"
import script from "./Conversations.vue?vue&type=script&lang=js"
export * from "./Conversations.vue?vue&type=script&lang=js"
import style0 from "./Conversations.vue?vue&type=style&index=0&id=1a9d05e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports